import { graphql, useLazyLoadQuery } from "react-relay";
import Button from "../../../../../Button";
import React, { useState } from "react";
import { Field, Form } from "formik";
import { useLazyQuery } from "@apollo/client";
import { gql } from "@apollo/client/core";

const ACTIVE_SLATES = graphql`
  query GreenMachineStatsActiveSlatesQuery {
    activeSlates {
      id
      prettyStartTime
      suffix
      gameType {
        name
        sport {
          name
        }
      }
    }
  }
`;

const STATS_CSV = gql`
  query GreenMachineStatsCSVQuery($slateId: ID!) {
    greenMachineSlateStats(slateId: $slateId) {
      csv
    }
  }
`;

export default function GreenMachineStats() {
  const [selectedSlateID, setSelectedSlateID] = useState(undefined);

  const activeSlates = useLazyLoadQuery(ACTIVE_SLATES);

  const [getCSV] = useLazyQuery(STATS_CSV, {
    onCompleted: (csv) => {
      let encodedUri = encodeURI(
        "data:text/plain;charset=utf-8," + csv.greenMachineSlateStats.csv
      );
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("class", new Date().getTime().toString());
      link.setAttribute("download", "green_machine_stats.csv");
      document.body.appendChild(link);
      link.click();
    },
    onError: () => {
      alert("Something went wrong. Please try again later.");
    },
    fetchPolicy: "network-only",
  });

  function exportGMStats(e) {
    e.preventDefault();

    getCSV({ variables: { slateId: selectedSlateID } });
  }

  function updateSelectedSlate(e) {
    e.preventDefault();

    setSelectedSlateID(e.target.value);
  }

  return (
    <div>
      <h1>Export Current GM Stats</h1>
      <select
        type="select"
        id="sport"
        name="sport"
        defaultValue={0}
        onChange={updateSelectedSlate}
        onBlur={updateSelectedSlate}
      >
        <option selected disabled value={0}>
          -- Select Slate --
        </option>
        {activeSlates.activeSlates.map((slate) => {
          return (
            <option value={slate.id} key={slate.id}>
              {slate.gameType.sport.name +
                " " +
                slate.gameType.name +
                slate.suffix +
                " (" +
                slate.prettyStartTime +
                ")"}
            </option>
          );
        })}
      </select>
      <Button form={true} onClick={exportGMStats} style={{ margin: "inherit" }}>
        Export
      </Button>
    </div>
  );
}
